import Driver from 'driver.js';
import {Panes} from "../controllers/panes";
import {GeoAppEvents} from "../controllers/events/geoapp_events";
import {FeaturesEvents} from "../services/events/FeaturesEvents";
import {SearchService} from "../services/search";
import * as SMapTourSteps from './steps';
import {
    TourStatus,
    _workAroundMoveNext,
    simulateOpenLayersEvent,
    togglePane as doTogglePane,
    waitFor,
    startWhenReady, timeoutHandler, onActivate, onReset
} from "./commands";
import {isPortrait} from "./util";
import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;


export function startTour(useDriver: Driver = null, startStepId: string = null, restarted: boolean = false): TourStatus {
    const driverOptions = {
        animate: true,
        padding: 0,
        stageBackground: "transparent",
        allowClose: false,
        onReset,
        onNext: () => {
            console.log('global onNext')
        }
    };

    onActivate();

    let driver = useDriver ? useDriver : new Driver(driverOptions);

    // let steps: any[];

    let steps: ((restarted?: boolean) => any[]) = null;

    let appElement = document.querySelector('[ng-app=map]');
    let app = window['angular'].element(appElement);
    let appScope: ng.IScope = app.scope();

    let mapService: () => IMapService = () => app.injector().get('landcareMapService');
    let searchService: SearchService;
    let coordAdjustment = () => app.injector().get('coordinateAdjustmentService');

    const workAroundMoveNext = (id) => _workAroundMoveNext(driver, steps(), id);

    const simpleNext = (aStep) => {
        driver.preventMove();
        requestAnimationFrame(() => workAroundMoveNext(aStep));
    };

    const doLinzQuery = (nextStep: string) => {
        waitFor('.inset-pane-sm [data-feature-action="Report based on LINZ Parcels"]')
            .then(element => {
                element.click();
                return waitFor('.inset-pane-sm .activated[data-feature-action="Report based on LINZ Parcels"]')
            })
            .then(() => {
                return mapService().getActiveClickInteraction()
            })
            .then((interaction) => {
                try {
                    simulateOpenLayersEvent(mapService().map, interaction, 'click', 0, 0);
                    return waitFor('.inset-pane-sm .report-preview');
                } catch (e) {
                    return waitFor('main');
                }
            }).then(() => {
                workAroundMoveNext(nextStep);
            }).then(timeoutHandler(driver));
    };

    const togglePane = (cssSelector, onOrOff?) => doTogglePane(appScope, cssSelector, onOrOff);

    steps = (restartTour: boolean) => {
        const theSteps = [
            {
                _id: 'a',
                element: 'main',
                popover: {
                    ...SMapTourSteps.introTablet,
                    position: 'mid-center'
                },
                onNext: () => simpleNext('b')
            },
            {
                _id: 'b',
                element: ".tile-nav-sm",
                popover: {
                    ...SMapTourSteps.mainButtonsTablet,
                    position: isPortrait() ? 'top-center' : 'right-center'
                },
                onNext: () => simpleNext('c'),
                onPrevious: () => simpleNext('a')
            },
            {
                _id: 'c',
                element: ".tile-nav-sm li.search",
                popover: {
                    ...SMapTourSteps.search,
                    position: isPortrait() ? undefined : 'right-top'/*,
                position: 'top-left'*/
                },
                onPrevious: () => simpleNext('b'),
                onNext: () => {
                    driver.preventMove();

                    appScope.$apply(() => {
                        (<HTMLElement>document.querySelector('[data-action="showModal:Search"]'))
                            .click();
                    });

                    waitFor('.modal.in:not(.ng-enter)')
                        .then(() => waitFor('.modal-content input[type=search]'))
                        .then((search: HTMLInputElement) => {
                            search.blur();
                            workAroundMoveNext('c2');
                        })
                        .then(timeoutHandler(driver));
                }
            },
            {
                _id: 'c2',
                element: '.modal-dialog',
                popover: {
                    ...SMapTourSteps.search,
                    position: 'bottom-center'
                },
                onNext: () => {
                    driver.preventMove();

                    const searchInput = <HTMLInputElement> document.querySelector(".modal-content input");
                    const textToType = "Mount Maunganui".split('').reverse();

                    searchInput.click();
                    searchInput.focus();
                    let typedCoord = '';

                    searchService = searchService || app.injector().get('searchService');

                    const typing = setInterval(() => {
                        if (textToType.length) {
                            appScope.$apply(() => {
                                const key = textToType.pop();
                                typedCoord += key;
                                searchInput.value = typedCoord;
                                searchInput.dispatchEvent(new KeyboardEvent('keydown', { key, bubbles: true, cancelable: true }));
                                searchInput.dispatchEvent(new KeyboardEvent('keyup', { key, bubbles: true, cancelable: true }));
                            });
                        } else {
                            driver.reset(true);
                            onActivate();
                            clearInterval(typing);

                            const coordinate = coordAdjustment().adjustCentreForScreenSpace([1879921.6885150375, 5830466.109067537], window['map'], 9);
                            searchService.animateZoomTo(coordinate, 15);
                            searchService.highlightLocation(coordinate, 4000);

                            setTimeout(() => {
                                searchInput.value = '';
                                (<HTMLElement> document.querySelector('[data-dismiss="modal"]'))
                                    .click();

                                setTimeout(() => {
                                    workAroundMoveNext('d');
                                }, 500)

                            }, 1500);

                        }
                    }, 20);
                },
                onPrevious: () => {
                    driver.preventMove();

                    const dismissModal = document.querySelector('[data-dismiss="modal"]');

                    if (dismissModal instanceof HTMLElement) {
                        dismissModal.click();
                    }

                    workAroundMoveNext('c')
                }
            },
            {
                _id: 'd',
                element: ".ol-zoom.ol-control",
                popover: {
                    ...SMapTourSteps.mapNavTouch,
                    position: "right-center"
                },
                onNext: () => simpleNext('e1'),
                onPrevious: () => {
                    driver.preventMove();

                    appScope.$apply(() => {
                        (<HTMLElement>document.querySelector('[data-action="showModal:Search"]'))
                            .click();
                    });

                    waitFor('.modal.in:not(.ng-enter)')
                        .then(() => workAroundMoveNext('c2'))
                        .then(timeoutHandler(driver));
                }
            },
            {
                _id: 'e1',
                element: ".pane-container.pane-collapse-sm .map-pane-sm li.layers",
                popover: {
                    ...SMapTourSteps.changingLayersTouch,
                    position: isPortrait() ? "top-center" : 'right-center'
                },
                onNext: () => {
                    driver.preventMove();
                    togglePane(Panes.Ids.LAYERS, true);
                    workAroundMoveNext('e2');
                },
                onPrevious: () => simpleNext('d')
            },
            {
                _id: 'e2',
                element: '.pane-container:not(.pane-collapse-sm) .inset-pane-sm',
                popover: {
                    ...SMapTourSteps.changingLayersTouch,
                    position: isPortrait() ? "top-center" : 'right-center'
                },
                onNext: () => {
                    driver.preventMove();
                    togglePane(Panes.Ids.LAYERS, false);
                    workAroundMoveNext('f1');
                },
                onPrevious: () => {
                    driver.preventMove();
                    togglePane(Panes.Ids.LAYERS, false);
                    workAroundMoveNext('e1');
                }
            },
            {
                _id: 'f1',
                element: '.pane-container.pane-collapse-sm .map-pane-sm li.features',
                popover: {
                    ...SMapTourSteps.reports,
                    position: isPortrait() ? 'top-right' : 'right-bottom'
                },
                onNext: () => {
                    driver.preventMove();
                    togglePane(Panes.Ids.FEATURES, true);
                    workAroundMoveNext('f2')
                },
                onPrevious: () => {
                    driver.preventMove();
                    togglePane(Panes.Ids.LAYERS, true);
                    workAroundMoveNext('e2');
                }
            },
            {
                _id: 'f2',
                element: '.pane-container:not(.pane-collapse-sm) .inset-pane-sm',
                popover: {
                    ...SMapTourSteps.reports,
                    position: isPortrait() ? 'top-center' : 'right-center'
                },
                onNext: () => simpleNext('g'),
                onPrevious: () => {
                    driver.preventMove();
                    togglePane(Panes.Ids.FEATURES, false);
                    workAroundMoveNext('f1');

                    // waitFor('.inset-pane-sm .pane-content:not(.ng-hide)')
                    //     .then(() => waitFor('.inset-pane-sm point-report-list'))
                    //     .then((list) => list.scrollIntoView())
                    //     .then(() => workAroundMoveNext('f1'))
                    //     .then(timeoutHandler(driver));
                }
            },
            {
                _id: 'g',
                stageBackground: "#fff",
                element: '.inset-pane-sm [data-feature-action=pointQuery]',
                padding: 4,
                popover: {
                    ...SMapTourSteps.soilSummary,
                    position: 'right-center'
                },
                onNext: () => {
                    driver.preventMove();
                    const reportButton = <HTMLElement> document.querySelector('.inset-pane-sm [data-feature-action="pointQuery"]');
                    const view = mapService().map.getView();
                    const coord = coordAdjustment().adjustCentreForScreenSpace([1879921.6885150375, 5830466.109067537], window['map'], 9);
                    view.setCenter(coord);
                    view.setZoom(9);
                    reportButton.click();
                    setTimeout(() => workAroundMoveNext('h'), 250);

                    /*appScope.$apply(() => {
                        appScope.$broadcast(GeoAppEvents.queryPoint, coord);
                        setTimeout(() => workAroundMoveNext(steps[7]), 250);
                    })*/
                },
                onPrevious: () => simpleNext('f2')
            },
            {
                _id: 'h',
                element: 'main',
                popover: {
                    ...SMapTourSteps.soilSummaryPt2,
                    position: 'mid-center'
                },
                onNext: () => {
                    driver.preventMove();

                    const coord = coordAdjustment().adjustCentreForScreenSpace([1879921.6885150375, 5830466.109067537], window['map'], 9);

                    appScope.$apply(() => {
                        appScope.$broadcast(GeoAppEvents.queryPoint, coord);
                        waitFor('smap-point-report')
                            .then(() => workAroundMoveNext('i'))
                            .then(timeoutHandler(driver));
                    });
                },
                onPrevious: () => {
                    driver.preventMove();
                    waitFor('.inset-pane-sm [data-feature-action="pointQuery"]')
                        .then(reportButton => {
                            reportButton.click();
                            return workAroundMoveNext('g')
                        })
                        .then(timeoutHandler(driver));
                }
            },
            {
                _id: 'i',
                element: '.pane-container:not(.pane-collapse-sm) .inset-pane-sm',
                popover: {
                    ...SMapTourSteps.soilSummaryPt3(false),
                    position: isPortrait() ? 'top-center' : 'right-center'
                },
                onNext: () => {
                    driver.preventMove();

                    waitFor('.pane-container:not(.pane-collapse-sm) .inset-pane-sm [data-action=showSMUFactsheet]')
                        .then(btn => {
                            btn.click();
                            workAroundMoveNext('i2');
                        })


                },
                onPrevious: () => {
                    driver.preventMove();
                    appScope.$apply(() => {
                        appScope.$broadcast(FeaturesEvents.hideReport);
                        appScope.$broadcast(GeoAppEvents.removeUnsavedPins);
                        waitFor('.inset-pane-sm .predefined-feature-actions')
                            .then(() => workAroundMoveNext('h'))
                            .then(timeoutHandler(driver));
                    });
                }
            },
            {
                _id: 'i2',
                element: '#report-container > .fullscreen-report',
                popover: {
                    ...SMapTourSteps.smuReport(true),
                    position: 'mid-center'
                },
                onNext: () => {
                    driver.preventMove();

                    waitFor('.fullscreen-report .report-toolbar .close-button')
                        .then(btn => {
                            btn.click();
                            appScope.$broadcast(FeaturesEvents.hideReport);
                            appScope.$broadcast(GeoAppEvents.removeUnsavedPins);
                            return waitFor('.inset-pane-sm .predefined-feature-actions');
                        }).then(() => workAroundMoveNext('j'));
                },
                onPrevious: () => {
                    driver.preventMove();
                    waitFor('.fullscreen-report .report-toolbar .close-button')
                        .then(btn => {
                            btn.click();
                            return waitFor('body:not(.report-active)');
                        })
                        .then(() => workAroundMoveNext('i'));
                }
            },
            {
                _id: 'j',
                padding: 10,
                stageBackground: '#fff',
                element: '.inset-pane-sm .features-container',
                popover: {
                    ...SMapTourSteps.areaReport,
                    position: isPortrait() ? 'top-center' : 'right-center'
                },
                onNext: () => simpleNext('k'),
                onPrevious: () => {
                    driver.preventMove();

                    const coord = coordAdjustment().adjustCentreForScreenSpace([1879921.6885150375, 5830466.109067537], window['map'], 9);

                    appScope.$apply(() => {
                        appScope.$broadcast(GeoAppEvents.queryPoint, coord);
                        waitFor('.pane-container:not(.pane-collapse-sm) .inset-pane-sm [data-action=showSMUFactsheet]')
                            .then(btn => {
                                btn.click();
                                return workAroundMoveNext('i2');
                            });
                    });
                }
            },
            {
                _id: 'k',
                stageBackground: "#fff",
                element: ".inset-pane-sm .predefined-feature-actions",
                padding: 10,
                popover: {
                    ...SMapTourSteps.predefinedFeatures,
                    position: isPortrait() ? 'top-center' : 'right-center',
                },
                onNext: () => {
                    driver.preventMove();
                    doLinzQuery('l');
                },
                onPrevious: () => simpleNext('j')
            },
            {
            _id: 'l',
            element: 'main',
            popover: {
                ...SMapTourSteps.linzParcel,
                position: 'mid-center'
            },
            onNext: () => {
                driver.preventMove();

                appScope.$apply(() => {
                    appScope.$broadcast(FeaturesEvents.hideReport);
                    appScope.$broadcast(Panes.Events.TOGGLE_PANE, Panes.Ids.FEATURES, false);

                    waitFor('.pane-container.pane-collapse-sm')
                        .then(() => workAroundMoveNext('m'))
                        .then(timeoutHandler(driver));
                });
            },
            onPrevious: () => {
                driver.preventMove();
                appScope.$apply(() => {
                    appScope.$broadcast(FeaturesEvents.hideReport);
                    workAroundMoveNext('k')
                    // setTimeout(() => , 30);
                });
            }
        },
            {
                _id: 'm',
                element: '[data-action="printMap"]',
                stageBackground: '#FFF',
                padding: 10,
                popover: {
                    ...SMapTourSteps.pdfMaps,
                    position: 'bottom-center'
                },
                onNext: () => {
                    driver.preventMove();
                    appScope.$apply(() => {
                        (<HTMLElement> document.querySelector('[data-action="printMap"]')).click();
                        setTimeout(() => workAroundMoveNext('n'), 100);
                    });
                },
                onPrevious: () => {
                    driver.preventMove();
                    const highlighted = driver.getHighlightedElement();
                    if (highlighted) (<any> highlighted).hidePopover();
                    togglePane(Panes.Ids.FEATURES);
                    setTimeout(() => doLinzQuery('l'), 150);
                }
            },
            {
                _id: 'n',
                element: '.print-pane',
                popover: {
                    ...SMapTourSteps.pdfMapPane,
                    position: 'mid-center'
                },
                onNext: () => {
                    driver.preventMove();
                    appScope.$apply(() => {
                        (<HTMLElement> document.querySelector('.print-pane .pane-heading')).click();
                        setTimeout(() => workAroundMoveNext('o'), 100);
                    });
                },
                onPrevious: () => {
                    driver.preventMove();
                    appScope.$apply(() => {
                        (<HTMLElement> document.querySelector('.print-pane .pane-heading')).click();
                        setTimeout(() => workAroundMoveNext('m'), 100);
                    });
                }
            },
            {
                _id: 'o',
                element: 'main',
                popover: {
                    ...SMapTourSteps.conclusion,
                    position: 'mid-center'
                },
                onPrevious: () => {
                    driver.preventMove();
                    (<HTMLElement> document.querySelector('[data-action="printMap"]')).click();
                    setTimeout(() => workAroundMoveNext('n'), 30);
                }
            }
        ];

        console.log(`tour: number of steps ${theSteps.length}`);

        if (restartTour) {
            theSteps.unshift({
                _id: 'restarted',
                element: '#ng-body',
                popover: {
                    ...SMapTourSteps.tourRestarted,
                    position: 'mid-center'
                },
                onNext: () => {
                    driver.preventMove();
                    theSteps.shift();
                    workAroundMoveNext('a');
                }
            })
        }

        return theSteps;
    };

    driver.defineSteps(steps(restarted));


    const ready = startWhenReady(driver, appScope, appElement, mapService());

    return <TourStatus> () => {
        return {
            driver,
            steps: steps(),
            ready,
            onOrientationChange: () => setTimeout(() => {
                console.log('redefining steps');

                const newSteps = steps(true);
                setTimeout(() => {
                    driver.defineSteps(newSteps);
                    startWhenReady(driver, appScope, appElement, mapService());
                });
            }, 100)
        }
    }
}

// window['smapDesktopTour'] = startTour;
